<template>
  <svg
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    width="48"
    height="48"
  >
    <path
      d="M12 12C12 10.8954 12.8954 10 14 10H16C17.1046 10 18 10.8954 18 12V20C18 21.1046 17.1046 22 16 22C14.8954 22 14 21.1046 14 20V14C12.8954 14 12 13.1046 12 12Z"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16 2C8.26801 2 2 8.26801 2 16C2 23.732 8.26801 30 16 30C23.732 30 30 23.732 30 16C30 8.26801 23.732 2 16 2ZM6 16C6 10.4772 10.4772 6 16 6C21.5228 6 26 10.4772 26 16C26 21.5228 21.5228 26 16 26C10.4772 26 6 21.5228 6 16Z"
    />
    <path
      d="M36.8787 18.866C35.8437 18.4801 34.6919 19.0063 34.306 20.0413C33.9201 21.0763 34.4464 22.2281 35.4813 22.614C37.0568 23.2014 38.4588 24.1765 39.5576 25.4493C40.6564 26.7221 41.4164 28.2514 41.7676 29.8958C42.1187 31.5401 42.0495 33.2465 41.5664 34.8571C41.0833 36.4676 40.2019 37.9304 39.0037 39.11C37.8055 40.2897 36.3292 41.1481 34.7113 41.606C33.0934 42.0639 31.3862 42.1065 29.7475 41.7298C28.1088 41.353 26.5915 40.5691 25.336 39.4507C24.0806 38.3322 23.1274 36.9151 22.5647 35.3307C22.195 34.2898 21.0515 33.7457 20.0107 34.1153C18.9698 34.485 18.4257 35.6284 18.7953 36.6693C19.5831 38.8876 20.9176 40.8714 22.6753 42.4373C24.4329 44.0032 26.5571 45.1006 28.8512 45.6281C31.1454 46.1555 33.5356 46.0959 35.8006 45.4549C38.0657 44.8138 40.1325 43.6119 41.81 41.9604C43.4875 40.3089 44.7214 38.2611 45.3978 36.0063C46.0741 33.7515 46.171 31.3626 45.6794 29.0605C45.1878 26.7584 44.1237 24.6173 42.5854 22.8355C41.0471 21.0536 39.0844 19.6883 36.8787 18.866Z"
    />
    <path
      d="M34.8442 26.3559C34.0687 25.5693 32.8024 25.5603 32.0158 26.3358C31.2293 27.1113 31.2203 28.3776 31.9958 29.1642L32.0016 29.17L27.7658 33.4058C26.9847 34.1868 26.9847 35.4532 27.7658 36.2342C28.5468 37.0153 29.8132 37.0153 30.5942 36.2342L36.2342 30.5942C37.0113 29.8171 37.0158 28.5585 36.2442 27.7759L34.8442 26.3559Z"
    />
  </svg>
</template>
